import { render } from "./QuestionPage.vue?vue&type=template&id=6e59f79d&scoped=true&ts=true"
import script from "./QuestionPage.vue?vue&type=script&lang=ts"
export * from "./QuestionPage.vue?vue&type=script&lang=ts"

import "./QuestionPage.vue?vue&type=style&index=0&id=6e59f79d&lang=sass&scoped=true"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e59f79d"]])

export default __exports__